import { Component, OnInit } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Application } from '../../../../enums/application.enums';
import { CommonService } from '../../services/common.service';

@Component({
  selector: 'app-subscription-upgrade-dialog',
  templateUrl: './subscription-upgrade-dialog.component.html',
  styleUrls: ['subscription-upgrade-dialog.component.scss']
})
export class SubscriptionUpgradeDialogComponent implements OnInit {
  planDate;
  planEndDate;
  pUserSubscriptionList;
  userSubscriptionList = [];
  futureExpireDate;
  plan;
  subscriptionPlan;
  currSelectedSubscription;
  activeSubscriptionNames;
  userProfile;

  constructor(
    private readonly modalService: BsModalService,
    public readonly cs: CommonService
  ) {}

  ngOnInit() {
    if (this.cs.isBrowser) {
      if (this.modalService?.config?.initialState) {
        if (Object.keys(this.modalService?.config?.initialState).length) {
          this.planDate =
            this.modalService?.config?.initialState.currSelectedSubscription;
          this.plan = this.modalService?.config?.initialState.selectedPlan;
          this.pUserSubscriptionList =
            this.modalService?.config?.initialState.pUserSubscriptionList;
          this.subscriptionPlan = this.modalService?.config?.initialState.type;
          this.currSelectedSubscription =
            this.modalService?.config?.initialState?.currSelectedSubscription;
          this.userProfile = this.modalService?.config?.initialState?.user;
        }
      }
      this.getAllSubscriptionListOfParentUser();
      this.activeSubscriptionNames = this.getCurrentSubscribedPlans();
    }
  }

  getPlanCreatorFullName() {
    if (this.currSelectedSubscription?.user_details) {
      return `${this.currSelectedSubscription?.user_details?.first_name} ${this.currSelectedSubscription?.user_details?.last_name}`.trim();
    }
    return '';
  }

  getAllSubscriptionListOfParentUser(): void {
    this.pUserSubscriptionList.forEach((ele) => {
      if ((ele?.plan_details?.user_email === this.planDate?.user_email) && ele?.expired_date) {
        this.planEndDate = new Date(Number(ele.expired_date));
        const expDate = new Date();
        expDate.setMonth(expDate.getMonth() + this.plan?.duration);
        this.futureExpireDate = expDate;
      }
    });
    this.userSubscriptionList.forEach((ele) => {
      ele?.plan_details?.forEach((pack) => {
        pack.is_subscribed = this.checkSubscribeStatus(ele, pack);
      });
    });
  }

  checkSubscribeStatus(obj, subplan): boolean {
    const arr = this.pUserSubscriptionList.filter(
      (ele) => ele.active && ele.subplan_id === subplan.id
    );
    return (
      arr.filter(
        (ele) =>
          ele.sk.split('#')[Application.TWO] ===
          obj.sk.split('#')[Application.ONE]
      ).length !== Application.ZERO
    );
  }

  /**
   * on close dialog
   */
  closeModal(): void {
    this.modalService.setDismissReason('close');
    this.modalService.hide();
  }

  moveAhead() {
    this.modalService.setDismissReason('move-ahead');
    this.modalService.hide();
  }

  getCurrentSubscribedPlans() {
    return (this.pUserSubscriptionList || [])
      .map((curr) =>
        curr.active &&
        curr?.plan_details?.user_details?.gsi4pk === this.userProfile?.gsi4pk
          ? (curr?.plan_details?.name ?? '')
          : ''
      )
      .filter((name) => name)
      .join(', ');
  }
}
